import React, { FC } from "react";
import { Argument } from "classnames/dedupe";

import useWatchState from "../../../hooks/useWatchState";
import { NavList, NavItem } from "../../Navigational";

export interface INavSwitcherProps {
  /**
   * Object of navigation items
   */
  navItems: { [key: string]: string };
  /**
   * Highlighting currently selected item
   */
  activeItem?: string;
  /**
   * Accessibility and keyboard tab
   */
  ariaLabel?: string;
  /**
   * Classes for styles
   */
  classes?: {
    root?: Argument;
    navItemRoot?: Argument;
  };
  /**
   * Function on clicking navigation item
   */
  onSelect?(id: string): void;
}

const NavSwitcher: FC<INavSwitcherProps> = ({
  navItems,
  activeItem,
  ariaLabel,
  classes,
  onSelect,
}) => {
  const [activeItemState, setActiveItemState] = useWatchState<string>({
    value: activeItem,
  });

  return (
    <NavList ariaLabel={ariaLabel} classes={{ root: classes?.root }}>
      {Object.values(navItems).map((val) => (
        <NavItem
          classes={{ root: classes?.navItemRoot }}
          key={val}
          active={activeItemState === val}
          text={val}
          isSimpleNavItem
          onClick={() => {
            setActiveItemState(val);
            onSelect?.(val);
          }}
        />
      ))}
    </NavList>
  );
};

export default NavSwitcher;
